export default __webpack_public_path__ + "static/media/640_business01-jp-web.ff1c7641.png";